import React, { ReactElement } from 'react';
import { Box } from '@mui/material';

export type RepliconSubstituteUserBannerProps = {
  navigationMetadata: any;
};
export const RepliconSubstituteUserBanner = (props: {
  navigationMetadata: any;
  menuOpen: boolean;
  isDocked: boolean;
}): ReactElement => {
  return (
    <>
      <Box
        id="substituteBanner"
        className="substituteBanner"
        sx={{
          marginLeft: '64px',
          ...(props.menuOpen && { marginLeft: '240px' }),
          ...(!props.isDocked && { marginLeft: '0px' })
        }}
      >
        <span
          id="substituteBannerIconContainer"
          className="substituteBannerIconContainer"
        ></span>
        <span id="substituteBannerMessage" className="substituteBannerMessage">
          {props?.navigationMetadata?.substituteUserMetadata?.subannerText}
        </span>
        <strong id="substituteUserName" className="substituteBannerUser">
          {' ' + props?.navigationMetadata?.substituteUserMetadata?.userName}
        </strong>
        <a
          href={props?.navigationMetadata?.substituteUserMetadata?.actionHref?.toString()}
          id="substituteBannerActionButton"
          className="substituteBannerActionButton"
        >
          {props?.navigationMetadata?.substituteUserMetadata?.actionText}
        </a>
      </Box>
    </>
  );
};
